import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  createSubscription,
  editSubscription,
  showSubscription,
} from '~/config/routes';
import List from './List';
import New from './New';
import Edit from './Edit';
import Show from './Show';
import { SubscriptionProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Subscription() {
  return (
    <SubscriptionProvider>
      <Switch>
        <Route
          exact
          path={createSubscription.spec}
          render={(props) => (
            <>
              <Can I="new" a="Subscriptions">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Subscriptions">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editSubscription.spec}
          render={(props) => (
            <>
              <Can I="edit" a="Subscriptions">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="Subscriptions">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showSubscription.spec}
          render={(props) => (
            <>
              <Can I="show" a="Subscriptions">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Subscriptions">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="Subscriptions">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Subscriptions">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </SubscriptionProvider>
  );
}
export default Subscription;
